// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://amjwnrglafnzwfrctqoh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFtanducmdsYWZuendmcmN0cW9oIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3NDQxMTgsImV4cCI6MjA3MzMyMDExOH0.iggN5wzgjGEQVIpN51ncENj9d8_jKFUw-lnfJ06pmHA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
